import { render, staticRenderFns } from "./BannerTextForm.vue?vue&type=template&id=0dfd0865&scoped=true&"
import script from "./BannerTextForm.vue?vue&type=script&lang=js&"
export * from "./BannerTextForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerTextForm.vue?vue&type=style&index=0&id=0dfd0865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfd0865",
  null
  
)

export default component.exports